module.exports = __webpack_public_path__ + "static/media/region_reunion.485f3abb.png";